function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/****************************************************************
 *
 * An extension of the Game Engine for single player games
 * to facilitate Arcade events like accept game and end game scenarios
 * so that the League Module can function correctly
 *
 *
 ***************************************************************/

var saito = require('../saito/saito');
var GameTemplate = require('./gametemplate');
var OnePlayerGameTemplate = /*#__PURE__*/function (_GameTemplate) {
  function OnePlayerGameTemplate(app) {
    var _this;
    _classCallCheck(this, OnePlayerGameTemplate);
    _this = _callSuper(this, OnePlayerGameTemplate, [app]);
    _this.minPlayers = 1;
    _this.maxPlayers = 1;
    _this.can_bet = 0;
    _this.statistical_unit = 'deal';
    _this.enable_observer = false;
    return _this;
  }
  _inherits(OnePlayerGameTemplate, _GameTemplate);
  return _createClass(OnePlayerGameTemplate, [{
    key: "returnState",
    value: function returnState() {
      var lifetime = {};
      if (this.loadGamePreference(this.name + '_stats')) {
        lifetime = this.loadGamePreference(this.name + '_stats');
      } else {
        lifetime.round = 0;
        lifetime.wins = 0;
        lifetime.losses = 0;
      }
      var state = {
        session: {},
        lifetime: {}
      };
      state.session.round = 0;
      state.session.wins = 0;
      state.session.losses = 0;
      state.lifetime = lifetime;
      return state;
    }

    // Create an exp league for single player games by default
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type == 'default-league') {
        var _obj = _superPropGet(OnePlayerGameTemplate, "respondTo", this, 3)([type]);
        _obj.ranking_algorithm = 'EXP';
        _obj.default_score = 0;
        return _obj;
      }
      return _superPropGet(OnePlayerGameTemplate, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "returnStatsHTML",
    value: function returnStatsHTML() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var adjustment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!title) {
        title = this.gamename + ' Stats';
      }
      var html = "<div class=\"solitaire-stats-overlay\">\n      <h1>".concat(title, "</h1>\n      <hr>\n      <div class=\"saito-table\">\n        <div class=\"saito-table-header\">\n          <div class=\"saito-table-row\">\n            <div></div>\n            <div>Session</div>\n            <div>Lifetime</div>        \n          </div>\n        </div>\n        <div class=\"saito-table-body\">\n          <div class=\"saito-table-row\">\n            <div class=\"saito-table-label\">Games Played:</div>\n            <div>").concat(this.game.state.session.round + adjustment, " </div>\n            <div>").concat(this.game.state.lifetime.round + this.game.state.session.round + adjustment, " </div>\n          </div>\n          <div class=\"saito-table-row\">\n            <div class=\"saito-table-label\">Games Won:</div>\n            <div>").concat(this.game.state.session.wins, " </div>\n            <div>").concat(this.game.state.lifetime.wins + this.game.state.session.wins, " </div>\n          </div>\n          <div class=\"saito-table-row\">\n            <div class=\"saito-table-label\">Win Rate (%):</div>\n            <div>");
      if (this.game.state.session.round + adjustment > 0) {
        html += Math.round(1000 * this.game.state.session.wins / (this.game.state.session.round + adjustment)) / 10;
      } else {
        html += 0;
      }
      html += "</div><div>";
      if (this.game.state.lifetime.round + this.game.state.session.round + adjustment > 0) {
        html += Math.round(1000 * (this.game.state.lifetime.wins + this.game.state.session.wins) / (this.game.state.lifetime.round + this.game.state.session.round + adjustment)) / 10;
      } else {
        html += 0;
      }
      html += "</div>\n          </div>\n        </div>\n      </div>\n      <div class=\"stats-menu-controls\"></div>\n    </div>";
      return html;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var c;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.game.player == 0)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return sconfirm('This is not a valid game! Return to Arcade');
            case 1:
              c = _context.v;
              if (c) {
                navigateWindow('/arcade');
              }
              return _context.a(2);
            case 2:
              this.game.over = 0;
              this.saveGame(this.game.id);
              _context.n = 3;
              return _superPropGet(OnePlayerGameTemplate, "render", this, 3)([app]);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "doWeHaveAnOngoingGame",
    value: function doWeHaveAnOngoingGame() {
      var _this$app;
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.options) !== null && _this$app !== void 0 && _this$app.games) {
        for (var i = 0; i < this.app.options.games.length; i++) {
          if (this.app.options.games[i].module === this.name) {
            if (this.app.options.games[i].over !== 1) {
              this.game = JSON.parse(JSON.stringify(this.app.options.games[i]));
              return 1;
            }
          }
        }
      }
      return 0;
    }

    //initializeSinglePlayerGame(game_data) {
  }, {
    key: "initializeGameFromAcceptTransaction",
    value: function () {
      var _initializeGameFromAcceptTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tx) {
        var txmsg, game_id;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              txmsg = tx.returnMessage();
              game_id = txmsg.game_id; //Load last session
              if (!this.loadGame()) {
                this.loadGame(game_id);
              }

              //Then overwrite with new id
              this.game.id = game_id;
              this.game.module = this.name;
              this.game.options = txmsg.options;
              this.game.originator = txmsg.originator; //Keep track of who initiated the game
              this.game.players_needed = 1; //So arcade renders correctly

              /*
              So people can close (i.e. hide) solitaire games between sessions, but we want the game to persist
              in the wallet (for localized long term stats tracking), we toggle between game.over = 0 and game.over = 2
              (over = 1 is reserved for when the game is over and cannot be played further and will/may trigger deletion)
              */
              this.game.over = 0;
              if (this.game.players_set == 0) {
                this.game.players = [];
                this.game.players.push(this.publicKey);
                this.game.accepted = this.game.players;
                this.game.step.players[this.publicKey] = 1;
                this.game.players_set = 1;
                this.game.player = 1;
                console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!! SINGLE PLAYER GAME CREATED !!!\n', '!!!!!!!!!!!!!!!!!!!!');
                console.log('My Public Key: ' + this.publicKey);
                console.log('My Position: ' + this.game.player);
                console.log('ALL KEYS: ' + JSON.stringify(this.game.players));
                console.log('saving with id: ' + game_id);
                console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n');
              } else {
                console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!! CONTINUING SINGLE PLAYER GAME !!!\n', '!!!!!!!!!!!!!!!!!!!!');
              }
              this.saveGame(game_id);
              _context2.n = 1;
              return this.initializeGameQueue(game_id);
            case 1:
              return _context2.a(2, this.game.id);
          }
        }, _callee2, this);
      }));
      function initializeGameFromAcceptTransaction(_x2) {
        return _initializeGameFromAcceptTransaction.apply(this, arguments);
      }
      return initializeGameFromAcceptTransaction;
    }()
  }, {
    key: "exitGame",
    value: function exitGame() {
      //Force these
      this.halted = 0;
      this.gaming_active = 0;
      this.updateStatusWithOptions('Saving game to the blockchain...');
      this.prependMove('EXITGAME');
      this.endTurn();
    }
  }, {
    key: "receiveStopGameTransaction",
    value: function () {
      var _receiveStopGameTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$game$state, _this$game$state2, _this$game$state3;
        var resigning_player,
          txmsg,
          msg,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              resigning_player = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;
              txmsg = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
              console.info('GTO: receiveStopGame', JSON.parse(JSON.stringify(this.game.state)));
              if (!(this.game.over > 0)) {
                _context3.n = 1;
                break;
              }
              if (resigning_player == this.publicKey && txmsg) {
                console.info('GTO: Receiving quit message from Arcade, delete game from wallet');
                this.removeGameFromOptions(this.game.id);
              }
              return _context3.a(2);
            case 1:
              msg = 'cancellation';
              if (((_this$game$state = this.game.state) === null || _this$game$state === void 0 || (_this$game$state = _this$game$state.session) === null || _this$game$state === void 0 ? void 0 : _this$game$state.wins) >= 0 && ((_this$game$state2 = this.game.state) === null || _this$game$state2 === void 0 || (_this$game$state2 = _this$game$state2.session) === null || _this$game$state2 === void 0 ? void 0 : _this$game$state2.losses) >= 0) {
                msg = "Wins: ".concat(this.game.state.session.wins, ", Losses: ").concat(this.game.state.session.losses);
              }
              if ((_this$game$state3 = this.game.state) !== null && _this$game$state3 !== void 0 && _this$game$state3.scores) {
                msg = 'Scores: ' + this.game.state.scores.join(', ');
              }
              this.game.over = 2;
              this.sendGameOverTransaction([], msg);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function receiveStopGameTransaction() {
        return _receiveStopGameTransaction.apply(this, arguments);
      }
      return receiveStopGameTransaction;
    }()
  }, {
    key: "receiveGameoverTransaction",
    value: function receiveGameoverTransaction(blk, tx, conf, app) {
      var _this2 = this;
      console.log('The game never ends when you play by yourself!');
      try {
        var _this$game$state4, _this$game$state5;
        if ((_this$game$state4 = this.game.state) !== null && _this$game$state4 !== void 0 && _this$game$state4.session) {
          for (var x in this.game.state.session) {
            this.game.state.lifetime[x] += this.game.state.session[x];
            this.game.state.session[x] = 0;
          }
        }
        if ((_this$game$state5 = this.game.state) !== null && _this$game$state5 !== void 0 && _this$game$state5.scores) {
          this.game.state.scores = [];
        }
      } catch (err) {
        console.error(err);
      }
      this.saveGamePreference(this.name + '_stats', this.game.state.lifetime);
      this.game.queue.push('READY');
      this.game.moves = [];
      this.saveGame(this.game.id);
      if (this.browser_active && this.request_exit) {
        siteMessage('Game saved, exiting now', 750);
        setTimeout(function () {
          _superPropGet(OnePlayerGameTemplate, "exitGame", _this2, 3)([]);
        }, 750);
      }
      return;
    }

    /**
     * Definition of core gaming logic commands
     */
  }, {
    key: "initializeQueueCommands",
    value: function initializeQueueCommands() {
      //Take all Game Engine Commands
      _superPropGet(OnePlayerGameTemplate, "initializeQueueCommands", this, 3)([]);

      //Add some more ones
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'EXITGAME') {
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          game_self.saveGame(game_self.game.id);
          game_self.request_exit = true;

          //
          // We want to auto-close single player games when we exit
          // which is basically resigning the game session
          //
          game_self.receiveStopGameTransaction();
          //Don't need to await because returning 0 and stopping the queue
          return 0;
        }
        return 1;
      });
    }
  }]);
}(GameTemplate);
module.exports = OnePlayerGameTemplate;